import React, { useState, useContext } from 'react';
import { PersonContext } from '../../context/PersonContext';
import './modify.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const PersonModify = () => {
  const { person, setPerson } = useContext(PersonContext);
  const [handphone, setHandphone] = useState(person.handphone);
  const [secretcode, setSecretcode] = useState('');
  const [authcode, setAuthcode] = useState('');
  const [isAuthcodeChecked, setIsAuthcodeChecked] = useState(false);
  const [error, setError] = useState('');
  const host = process.env.REACT_APP_RESTAPI_URL;

  const handleSendAuthCode = async () => {
    const url = `${host}/oauth/sendUms`;
    console.log(`인증번호 발송 시도 : ${url}`);
    setAuthcode(''); // 인증번호를 초기화합니다.
    setSecretcode(''); // 입력된 인증번호를 초기화합니다.
    setIsAuthcodeChecked(false); // 인증번호 확인 상태를 초기화합니다.

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: person.name, birth: person.birth, handphone }),
      });
      if (!response.ok) throw new Error('인증번호 발송 실패');
      const data = await response.json();
      console.log(data);
      console.log(`인증번호 발송 성공 : ${data}`);
      setAuthcode(data.authcode); // 인증번호가 발송되었음을 표시합니다.
      alert('인증번호가 발송되었습니다. 확인 후 입력해주세요.');
    } catch (error) {
      console.error('인증번호 발송 오류:', error);
      setError(error.message);
    }
  };

  const handleModify = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_RESTAPI_URL}/person`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ handphone }),
      });

      if (!response.ok) {
        throw new Error('정보 수정 실패');
      }

      const data = await response.json();
      //console.log(data);
      setPerson(data.data);
      setError('');
      alert('정보가 수정되었습니다.');
      // 페이지를 새로고침하거나 리다이렉트할 수 있습니다.
      window.location.href='/';
    } catch (error) {
      setError(error.message);
    }
  };

  const handleVerifyAuthCode = () => {
    console.log(`인증번호 확인 시도 : ${authcode} / ${secretcode}`);
    if (!secretcode) {
      setError('인증번호를 입력해주세요.');
      return;
    }

    if (secretcode !== authcode) {
      setError('인증번호가 일치하지 않습니다. 다시 확인해주세요.');
      return;
    }

    setError('');
    setIsAuthcodeChecked(true); // 인증번호 확인 상태를 true로 설정합니다.
  };

  return (
    <div id="person_modify">
      <div className="head">
        <h1>정보 수정</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>성명</label>
            <span>
              {person.name}
            </span>
          </li>
          <li>
            <label>생년월일</label>
            <span>
              {person.birth}
            </span>
          </li>
          <li>
            <label>핸드폰</label>
            <span>
              <input
                type="text"
                placeholder="핸드폰번호를 숫자로만 입력하세요."
                value={handphone}
                onChange={(e) => setHandphone(e.target.value)}
                className='handphone'
              />
              <button onClick={handleSendAuthCode}>{ authcode ? '재전송' : '발송하기' }</button>
            </span>
          </li>
          {authcode && (
          <li>
            <label>인증번호</label>
            <span>
              <input
                type="text"
                placeholder="인증번호를 입력하세요."
                value={secretcode}
                onChange={(e) => setSecretcode(e.target.value)}
                className='secretcode'
              />
              <button onClick={handleVerifyAuthCode}>확인하기</button>
            </span>
          </li>
          )}
        </ul>
        {error && <div className="error">{error}</div>}
        <div>
          <button className="modify" onClick={handleModify} disabled={!isAuthcodeChecked}>수정</button>
        </div>
      </div>
    </div>
  );
};

export default PersonModify;